import { render } from "./ActionMenu.vue?vue&type=template&id=4cb05408"
import script from "./ActionMenu.vue?vue&type=script&lang=js"
export * from "./ActionMenu.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__